module.exports = __webpack_public_path__ + "img/fridges.de8d7467.png";